var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5C4 5.67157 4 4.25736 4.87868 3.37868C5.75736 2.5 7.17157 2.5 10 2.5H14C16.8284 2.5 18.2426 2.5 19.1213 3.37868C20 4.25736 20 5.67157 20 8.5V16.5C20 19.3284 20 20.7426 19.1213 21.6213C18.2426 22.5 16.8284 22.5 14 22.5H10C7.17157 22.5 5.75736 22.5 4.87868 21.6213C4 20.7426 4 19.3284 4 16.5V8.5Z",
    stroke: "currentColor",
    strokeOpacity: 0.86,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8978 16.5H7.89778C6.96781 16.5 6.50282 16.5 6.12132 16.6022C5.08604 16.8796 4.2774 17.6883 4 18.7235",
    stroke: "currentColor",
    strokeOpacity: 0.86,
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5H16",
    stroke: "currentColor",
    strokeOpacity: 0.86,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11H13",
    stroke: "currentColor",
    strokeOpacity: 0.86,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBook);
export default __webpack_public_path__ + "static/media/ic_book.32567ebcd4083084f09311886e5c6534.svg";
export { ForwardRef as ReactComponent };